import { Dispatch, SetStateAction, useEffect, useState } from "react";

interface UseDelayedValueOptions {
    delayValueInMiliseconds?: number;
}

export const useDelayedState = <T extends string | number | undefined>(
    initialValue: T,
    options?: UseDelayedValueOptions
): [T, T, Dispatch<SetStateAction<T>>] => {
    const [delayedValue, setDelayedValue] = useState<T>(initialValue);
    const [value, setValue] = useState<T>(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (value !== delayedValue) {
                setDelayedValue(value);
            }
        }, options?.delayValueInMiliseconds ?? 500);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [value]);

    return [delayedValue, value, setValue];
};
